import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getModuleData } from '../../../selectors/modules';
import { getProfileOwnerUser } from '../../../selectors/users';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { Props } from './Tiers';

type StateProps = Pick<Props, 'tiers' | 'profileOwnerUser'>;
type DispatchProps = Pick<Props, never>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const { tiers: tiersIds = [] } = getModuleData(state, ownProps.moduleId);
  const tiers = getDeviationsByIds(state, tiersIds).filter(
    tier => ownProps.isOwner || tier.isPublished
  );
  return {
    tiers,
    profileOwnerUser: getProfileOwnerUser(state),
  };
};

export default connect(mapStateToProps);
